import { useQuery } from "@tanstack/react-query";
import { Page, ScenarioDeploy } from "@/model";
import { compareDate } from "@/util/dateUtil";
import deployRepository from "@/repository/deployRepository";


export const usePaginatedScenarioDeploy = (scenarioId: string, page?: number, size?: number) => {
    return useQuery<Page<ScenarioDeploy>>({
        queryKey: ['page-scenario-deploys', scenarioId, 'page', page, size],
        queryFn: async () => {
            const response = await deployRepository.find(scenarioId, page, size);
            if (response.data.content) {
                response.data.content = [...(response.data.content ?? [])].sort((a, b) => {
                    return compareDate(a.created_at, b.created_at, "desc");
                });
            }
            return response.data;
        },
        enabled: !!scenarioId
    });
};
